import { withStyles } from '@material-ui/core/styles';
import TableRow from '@material-ui/core/TableRow';

export const BaseTableRow = withStyles((theme) => ({
  head: {
    backgroundColor: theme.palette.primary.contrastText,
    color: theme.palette.common.black,
    fontWeight: 500,
    fontSize: '14px',
    borderRadius: '4px',
  },
  root: {
    height: '45px',
    fontSize: 14,
  },
}))(TableRow);
